/**
 * AdvancedSettingsNotice (#2310) — a plain caution banner at the top of the
 * advanced model-settings screens (Assignments, Prompts, Budgets & caps).
 *
 * Those screens let an operator change tuned defaults that affect test quality
 * and cost. The note tells a casual operator to think twice before changing
 * them. One reusable component (not copy-pasted text) so the copy stays
 * identical across the screens. Uses the app's `warning` surface — the same
 * border-warning / bg-warning/10 pattern used for inline warnings elsewhere.
 */
import { AlertTriangle } from 'lucide-react'

export function AdvancedSettingsNotice() {
  return (
    <div
      role="note"
      className="flex items-start gap-2.5 rounded-md border border-warning bg-warning/10 px-3.5 py-3 text-sm"
    >
      <AlertTriangle aria-hidden="true" className="mt-px h-[18px] w-[18px] flex-none text-warning" />
      <p className="text-muted-foreground">
        <span className="font-medium text-foreground">These are advanced settings.</span>{' '}
        The defaults are tuned for you — changing them can affect your tests' quality and cost.
        If you're not sure, it's best to leave them as they are.
      </p>
    </div>
  )
}
